import { NOTIFY_APPOINTMENT, NOTIFY_SYSTEM } from './notifyTypes'

export default {
  [NOTIFY_APPOINTMENT](state, data) {
    state.notifyList = data;
  },

  [NOTIFY_SYSTEM](state, data) {
    state.notifySystemList = data;
  },
}
